(function () {
  function init() {
    if (window.Shopify && window.Shopify.designMode) return;

    if (window.variantStrings) {
      window.variantStrings.unavailable = 'Please select a size';
    }

    document.querySelectorAll('product-info').forEach(initOne);
  }

  function initOne(productInfo) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('variant')) return;

    const fieldsets = productInfo.querySelectorAll('.product-form__input');
    let sizeFieldset = null;
    fieldsets.forEach(function (fs) {
      const legend = fs.querySelector('legend, label');
      if (legend && /size/i.test(legend.textContent || '')) {
        sizeFieldset = fs;
      }
    });
    if (!sizeFieldset) return;

    const radios = sizeFieldset.querySelectorAll('input[type="radio"]');
    const selectEl = sizeFieldset.querySelector('select');

    if (radios.length >= 2) {
      let hadChecked = false;
      radios.forEach(function (r) {
        if (r.checked) hadChecked = true;
        r.checked = false;
      });
      if (hadChecked && radios[0]) {
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (selectEl && selectEl.options.length >= 2) {
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select a size';
      placeholder.selected = true;
      placeholder.disabled = true;
      selectEl.insertBefore(placeholder, selectEl.firstChild);
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
